import React from "react";
import "./Footer.css";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaPhone, FaEnvelope } from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Colonne 1 : Informations de l'entreprise */}
        <div className="footer-column">
          <h3>ETOILE BRICOLAGE</h3>
          <p>332 BD BRAHIM ROUDANI, MAARIF</p>
          <p>CASABLANCA</p>
          <p>
            <FaPhone /> (+212) 6 60 41 19 27
          </p>
          <p>
            <FaEnvelope /> contact@etoilebricolage.com
          </p>
        </div>

        {/* Colonne 2 : Liens Utiles */}
        <div className="footer-column">
          <h3>LIENS UTILES</h3>
          <ul>
            <li><a href="/about">Qui sommes-nous ?</a></li>
            
            <li><a href="/products">Nos Produits</a></li>
            <li><a href="/contact">Nous Contacter</a></li>
          </ul>
        </div>

        {/* Colonne 3 : Réseaux Sociaux */}
        <div className="footer-column">
          <h3>NOUS SUIVRE</h3>
          <div className="social-icons">
            <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="https://www.linkedin.com/company/etoile-bricolage/" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn />
            </a>
          </div>
        </div>
      </div>

      {/* Bas du footer */}
      <div className="footer-bottom">
        <p>ETOILE BRICOLAGE © 2024. Tous droits réservés.</p>
      </div>
    </footer>
  );
}

export default Footer;
